export default __webpack_public_path__ + "static/media/information-mau.11a3bc53.svg";